import { UCError, UCPayload, UCPayloadType } from "../generated/proto-ts/main"

// Successful storage commands acknowledge with an empty UCAck{}. Its bool
// defaults to false; rejection is communicated by the SICO_ERROR payload type.
// Call only after correlating the response UUID with the pending request.
export function validateRegulatoryResponse(expected: UCPayloadType, payload: UCPayload): void {
  if (payload.type === UCPayloadType.SICO_ERROR)
    throw new Error(UCError.deserializeBinary(payload.data).value)
  if (payload.type !== expected) throw new Error("Réponse inattendue du serveur.")
}
